import {
  IVisualizationState,
  IPeerGroupTabsProps,
  IFilter,
  round,
} from "../../lib/http";
import * as React from "react";
import { Panel } from "react-bootstrap";
import * as ReactHighcharts from "react-highcharts";

export class Employees extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["Other_T_V19_Vis19Column"]
    );

    const selectedLightColor = "#8EA9DB";
    const selectedDarkColor = "#305496";
    const nonselectedLightColor = "#D9E1F2";
    const nonselectedDarkColor = "#B4C6E7";

    const paidData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
          y:
            parseFloat(
              (dataPoint["Other_N_V19_PaidWages"] * 100.0).toFixed(1)
            ) * 1.0,
          color: selectedLightColor,
          dataLabels: { color: "#fff" },
        }
        : {
          y:
            parseFloat(
              (dataPoint["Other_N_V19_PaidWages"] * 100.0).toFixed(1)
            ) * 1.0,
          color: nonselectedLightColor,
        }
    );

    const unpaidData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
          y:
            parseFloat(
              (dataPoint["Other_N_V19_UnpaidWages"] * 100.0).toFixed(1)
            ) * 1.0,
          color: selectedDarkColor,
          dataLabels: { color: "#fff" },
        }
        : {
          y:
            parseFloat(
              (dataPoint["Other_N_V19_UnpaidWages"] * 100.0).toFixed(1)
            ) * 1.0,
          color: nonselectedDarkColor,
        }
    );

    const title = currentSet ? currentSet["Other_T_V19_Vis19Title"] : "";
    const unpaidTitle = currentSet
      ? currentSet["Other_T_V19_UnpaidBubble"]
      : "";
    const paidTitle = currentSet ? currentSet["Other_T_V19_PaidBubble"] : "";
    const series = [
      {
        name: unpaidTitle,
        data: unpaidData,
        borderWidth: 1,
        borderColor: "#a1a1a1",
      },
      {
        name: paidTitle,
        data: paidData,
        borderWidth: 1,
        borderColor: "#a1a1a1",
      },
    ];

    this.setState({ title, series, categories });
  }

  static getChartConfig(categories, series) {
    return {
      chart: {
        type: "column",
        height: 300,
      },
      title: {
        text: "No Paid Employees",
        floating: true,
        x: -250,
        y: 65,
        style: {
          fontSize: "12px",
          color: "#666666",
        },
      },
      subtitle: {
        text: "Paid Employees",
        floating: true,
        x: 300,
        y: 220,
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
            color: "#a1a1a1",
            format: "{y}%",
            style: {
              textOutline: false,
            },
          },
        },
      },
      series,
    };
  }

  render() {
    const { title, loading, categories, series } = this.state;
    return (
      <Panel>
        <div className="panel-body text-center">
          {title}
          {loading && <i className="fa fa-cog fa-spin"></i>}
        </div>
        <div className="panel-body">
          <ReactHighcharts
            config={Employees.getChartConfig(categories, series)}
            ref="chart"
          />
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Other/Employees/index.tsx